import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup-overlay"
}
const _hoisted_2 = { class: "content-frame" }
const _hoisted_3 = { class: "loading-circular" }
const _hoisted_4 = { style: {"transform":"rotate(-90deg)"} }
const _hoisted_5 = {
  height: "100%",
  viewBox: "0 0 20 20",
  width: "100%",
  style: {"overflow":"visible"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.loadingOverlayStateStore.state.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("circle", {
                      cx: "50%",
                      cy: "50%",
                      fill: "none",
                      "stroke-width": "2",
                      r: "9",
                      stroke: "gray",
                      "stroke-linecap": "square",
                      style: {"stroke-dashoffset":"9","stroke-dasharray":"9"}
                    }, null, -1)
                  ]))]))
                ])
              ]),
              _createElementVNode("div", {
                class: "message",
                style: _normalizeStyle({fontSize: _ctx.FontSizes.large1})
              }, _toDisplayString(_ctx.message), 5)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}